import React from "react";
import styled from "styled-components";
import IcomoonIcon from "@icons/IcomoonIcon";
import { LanguageKey } from "@/types/generated/LanguageKey";
import { translate } from "@/hooks/useLanguage";

const RefreshOverlayStyle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.65);
  border-radius: 4px;
  z-index: 1001;
`;

export const LoaderStyle = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translate(-50%, -50%);
  z-index: 1010;
`;

const LoadingText = styled.div`
  margin-top: 8px;
  font-size: 13px;
  color: #5a7a9a;
  white-space: nowrap;
`;

export interface LoaderSpinnerProps {
  loading?: boolean;
  top?: string | number;
  minHeight?: string | number;
}

const LoaderSpinner: React.FC<LoaderSpinnerProps> = ({
  loading = false,
  top,
  minHeight,
}) => {
  return (
    <div style={{ display: loading ? "block" : "none", minHeight: minHeight }}>
      <RefreshOverlayStyle />
      <LoaderStyle style={{ top: top }}>
        <IcomoonIcon
          icon="spinner9"
          iconClassName="icon-spin"
          color="#75b9e6"
          size={24}
        />
        <LoadingText>{translate(LanguageKey.loading_key)}</LoadingText>
      </LoaderStyle>
    </div>
  );
};

export default LoaderSpinner;
